import { format2 } from 'utils/number';

/**
 * Shared money/number formatters for the royalty-checks feature.
 * Null renders as the em-dash placeholder; amounts are prefixed with `$`.
 */

export const fmtAmount = (n: number | null): string => {
  if (n === null) return '--';
  return `$${format2(n)}`;
};

export const fmtNumber = (n: number | null): string => {
  if (n === null) return '--';
  return String(n);
};
